export const updateWrapup = wrapupState => {
  return {
    type: 'UPDATE_WRAPUP',
    wrapupState,
  };
};
